import { splitString } from './helpers.js';

export const splitWords = () => {
  if (document.querySelector('.section-hero .hero__title h1')) {
    splitString(document.querySelector('.section-hero .hero__title h1'));
  }
  if (document.querySelector('.article__hero .hero__title h1')) {
    splitString(document.querySelector('.article__hero .hero__title h1'), false);
  }
};
